import Phaser from 'phaser';
import { musicDown } from '../SoundManager';
import gameData from '../gameData';
import IceCreamData from '../IceCreamData';
import ItemMenu from '../ui/ItemMenu';
import ABCyaPhaser from '@abcya/abcya_phaser';
import SoundAssetKeys from '../SoundAssetKeys';
import WorkArea from '../makeanicecream/WorkArea';
import Hud from '../ui/Hud';
import UIAssetKeys from '../UIAssetKeys';
import BearCharacter from '../characters/BearCharacter';
import FinishedScreen from './FinishedScreen';
import LocalizationSoundAssetKeys from '../Localization-SoundAssetKeys';

export default class GameScreen extends Phaser.Scene {
  static get KEY() { return 'GameScreen'; }

  constructor() {
    super({ key: GameScreen.KEY });
  }

  create() {
    musicDown(this);

    ABCyaPhaser.Images.addImage(0,0,UIAssetKeys._LandscapeMainBackground_4x3, this).setOrigin(0);

    this.shouldShowHelp = gameData.shouldShowHelp;

    this.menuData = IceCreamData.menuData;
    this.catIndex = [];
    for (let i = 0; i < this.menuData.length; i++) {
      this.catIndex.push(this.menuData[i].category);
    }

    this.menu = new ItemMenu(this, this.handleMenuSelected.bind(this), this.handleItemAction.bind(this));
    this.menu.y = (this.scale.height - this.menu.workingHeight) / 2;

    const workX = 290;
    this.workArea = new WorkArea(this, workX, this.menu.y);

    this.bearChar = new BearCharacter(this, 690, 376);

    const pos = this.workArea.workAreaPostions;
    this.hud = new Hud(this, pos.left, pos.right);

    this.add.existing(this.menu);
    this.add.existing(this.workArea);

    this.add.existing(this.bearChar);
    this.add.existing(this.hud);

    this.bearChar.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.clickbear, this);
    this.bearMoves = ['Standing', 'Jump', 'Leaning'];
    this.nextBearMove = 13;
    this.blinkWaiter = Phaser.Math.Between(10,30);

    this.beginIntro();
  }

  clickbear () {
    if (!this.bearChar.busyTimeline) this.bearChar.playLeaningAnimation();
  }

  handleMenuSelected (menuIndex) {
    this.beginIntroTimer?.remove();
    this.beginIntroTimer = null;

    this.hud.stopHelpPoints();
    const cat = this.menuData[menuIndex].category;

    this.workArea.menuChange(cat);
    this.showHelpFor(cat, this.menuData[menuIndex].helpSound);
  }

  showHelpFor (cat, helpSoundId) {
    if (this.shouldShowHelp === false) return;
    this.playInstructSound(helpSoundId);
    if (cat === 'Flavor') {

    }
    else if (cat === 'Whipped Cream') {
      const pos = this.workArea.workAreaPostions;

      this.hud.showHelper(pos.centerX, pos.top, pos.centerX, pos.top + 150, 1000, 400);
    }
    else if (cat === 'Container') {
      if (this.workArea.sundaeInfo.container < 0) {
        const pointPositions = this.menu.getHelperLocations();

        this.hud.showHelpPoints(pointPositions);
      }
    }
  }

  playInstructSound (sndId) {
    if (this.instructSound) {
      this.instructSound.stop();
      this.instructSound.destroy();
    }
    this.instructSound = ABCyaPhaser.Audio.createSound(this, 1, false, 0, ABCyaPhaser.Audio.LOCALIZATION_AUDIO_SPRITE);
    ABCyaPhaser.Audio.playSound(sndId, this.instructSound);
  }

  handleItemAction (actionType, actionValue) {
    if (actionType === 'Container') {
      this.workArea.selectContainer(actionValue);

      this.menu.enableFlavorsButton();
    }
    else if (actionType === 'Flavor') {
      const showWaitTime = this.workArea.selectFlavor(actionValue);
      this.menu.enableAllButtons();

      if (showWaitTime > 0) {
        this.hud.showTabButtons(showWaitTime);
      }
    }
    else if (actionType === 'Sauce') {
      const color = this.menuData[this.menu.currentMenu].colors[actionValue - 1];

      this.workArea.selectSauce(actionValue, color);
      ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._click, this);
    }
    else if (actionType === 'Toppings') {
      this.workArea.selectTopping(actionValue);
      ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._click, this);

    }
    else if (actionType === 'Whipped Cream') {
      this.workArea.selectWhipping(actionValue);
      ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._click, this);

    }
    else {
      console.error(`error handling item action: ${actionType}`);
    }
  }

  handleStartOver () {
    this.workArea.resetEverything();
    this.menu.reset();
    this.hud.hideTabButtons();
  }

  async beginServing () {
    if (this.instructSound) {
      this.instructSound.stop();
      this.instructSound.destroy();
      this.instructSound = null;
    }
    const container = this.workArea.sundaeInfo.container;
    const containerIsDish = this.workArea.sundaeInfo.containerIsDish;

    const userSundayInfo = {
      container,
      containerIsDish,
      layerInfo: []
    };

    const scoopCount = this.workArea.sundaeInfo.scoops.length;
    let thislayer = null;
    let scoop = null;
    for (let s = 0; s < scoopCount; s++) {
      scoop = this.workArea.sundaeInfo.scoops[s];
      thislayer = { flavor: scoop.flavorValue, sauces: [0,0,0,0], whippedcreams: [0,0,0,0], toppings: [0,0,0,0,0] };

      const stuffCount = scoop.toppingStuff.length;
      let thisStuff = null;
      for (let i = 0; i < stuffCount; i++) {
        thisStuff = scoop.toppingStuff[i];
        switch (thisStuff.toppingType) {
          case 'sauce':
            thislayer.sauces[thisStuff.sauceValue - 1]++;
            break;

          case 'cream':
            thislayer.whippedcreams[thisStuff.creamValue - 1]++;
            break;

          case 'topping':
            thislayer.toppings[thisStuff.toppingValue - 1]++;
            break;
        }
      }
      userSundayInfo.layerInfo.push(thislayer);
    }

    const img = await this.workArea.getCurrentCreationNewImage();
    img.x = this.workArea.workAreaPostions.left;

    gameData.userImage = img;
    gameData.sundayInfo = userSundayInfo;
    gameData.containerDishName = null;
    if (this.workArea.sundaeInfo.containerIsDish) {
      gameData.containerDishName = this.workArea.containerSprite.frame.name;
    }
    gameData.shouldShowHelp = true;

    this.scene.start(FinishedScreen.KEY);
  }

  stopInstructSound () {
    if (this.instructSound) {
      this.instructSound.stop();
      this.instructSound.destroy();
      this.instructSound = null;
    }
  }

  async sayCheese () {
    const img = await this.workArea.getCurrentCreationNewImage(undefined, 900);
    return img;
  }

  beginIntro () {
    const x = this.menu.x;
    this.menu.x = -this.menu.workingWidth * 2;
    ABCyaPhaser.Tweens.addTween(this.menu, 320, { x }, Phaser.Math.Easing.Linear);
    this.beginIntroTimer = this.time.delayedCall(280, () => {
      this.beginIntroTimer = null;
      this.menuIntroFinished();
      this.workArea.doIntro();
    });
  }

  menuIntroFinished () {
    const time = this.menu.finishIntro();
    this.beginIntroTimer = this.time.delayedCall(time, this.showFirstHelp, null, this);
  }

  showFirstHelp () {
    this.beginIntroTimer = null;
    if (this.shouldShowHelp === false) return;
    this.playInstructSound(LocalizationSoundAssetKeys._Cone_Container);

    const pointPositions = this.menu.getHelperLocations();
    this.hud.showHelpPoints(pointPositions);
  }

  update(time, delta) {
    const dt = delta / 1000;
    this.workArea.update(dt);

    if (!this.bearChar.busyTimeline) {
      this.blinkWaiter -= dt;
      this.nextBearMove -= dt;
      if (this.blinkWaiter <= 0) {
        this.bearChar.playBlinkAnimation();
        this.blinkWaiter = Phaser.Math.Between(10,48);
      }
      else if (this.nextBearMove <= 0) {
        const move = Phaser.Utils.Array.GetRandom(this.bearMoves);
        switch (move) {
          case 'Standing':
            this.bearChar.playStandingAnimation();
            break;
          case 'Jump':
            this.bearChar.playJumpingAnimation();
            break;
          case 'Leaning':
            this.bearChar.playLeaningAnimation();
            break;
        }
        this.nextBearMove = Phaser.Math.Between(10,30);
      }
    }
  }
}